import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { MaterialModule } from "@app/material.module";
import { FrillButtonComponent } from "./frill-button.component";
import { FrillButtonService } from "./frill-button.service";

@NgModule({
	declarations: [FrillButtonComponent],
	imports: [CommonModule, MaterialModule],
	exports: [FrillButtonComponent],
})
export class FrillButtonModule {
	static forRoot(): ModuleWithProviders<FrillButtonModule> {
		return {
			ngModule: FrillButtonModule,
			providers: [FrillButtonService],
		};
	}
}
